/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Menu } from "antd";
import {
  SnippetsOutlined,
  ThunderboltOutlined,
  HomeOutlined,
  DollarOutlined,
  GroupOutlined,
  TeamOutlined,
  ToolOutlined,
  UsergroupAddOutlined,
  BookOutlined,
  RedoOutlined,
  TableOutlined,
  LaptopOutlined,
  FileDoneOutlined,
  DeliveredProcedureOutlined,
  FolderViewOutlined,
  SafetyOutlined,
  RetweetOutlined,
  FileSyncOutlined,
  MacCommandOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  FileZipOutlined,
  EyeOutlined,
  LoginOutlined,
  AlertOutlined,
  RiseOutlined,
  ApiOutlined,
  EnvironmentOutlined,
  SnippetsFilled,
  DeploymentUnitOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./estilos.css";
import { useUserContext } from "../../contexts/usersContext";

const MenuPrincipal = () => {
  const { currentUser } = useUserContext();

  const items = [
    currentUser.is_superuser ||
    currentUser.is_manager ||
    currentUser.is_financial ||
    currentUser.is_staff
      ? {
          label: "Cartorio",
          key: "CartorioMenu",
          icon: <HomeOutlined />,
          children: [
            {
              label: <Link to="/Cartorio">Cartorio</Link>,
              key: "Cartorio",
              icon: <HomeOutlined />,
            },
            {
              label: <Link to="/Geolocalização">Geolocalização</Link>,
              key: "Geolocalização",
              icon: <EnvironmentOutlined />,
            },
          ],
        }
      : null,
    currentUser.is_superuser || currentUser.is_manager || currentUser.is_staff
      ? {
          label: "Emolumento",
          key: "EmolumentoMenu",
          icon: <DollarOutlined />,
          children: [
            {
              label: "Selo Grupo",
              key: "SeloGrupoMenu",
              icon: <GroupOutlined />,
              children: [
                {
                  label: <Link to="/SeloGrupo">Selo Grupo</Link>,
                  key: "SeloGrupo",
                  icon: <GroupOutlined />,
                },
                {
                  label: <Link to="/SeloGrupoPai">Selo Grupo Pai</Link>,
                  key: "SeloGrupoPai",
                  icon: <TeamOutlined />,
                },
                {
                  label: <Link to="/SeloGrupoFilho">Selo Grupo Filho</Link>,
                  key: "SeloGrupoFilho",
                  icon: <TeamOutlined />,
                },
              ],
            },
            {
              label: <Link to="/EmolumentoPeriodo">Emolumento Período</Link>,
              key: "EmolumentoPeriodo",
              icon: <DollarOutlined />,
            },
            {
              label: <Link to="/Emolumento">Emolumento</Link>,
              key: "Emolumento",
              icon: <DollarOutlined />,
            },
            {
              label: <Link to="/EmolumentoItem">Emolumento Item</Link>,
              key: "EmolumentoItem",
              icon: <DollarOutlined />,
            },
          ],
        }
      : null,

    currentUser.is_superuser || currentUser.is_manager || currentUser.is_staff
      ? {
          label: "Sistema",
          key: "SistemaMenu",
          icon: <LaptopOutlined />,
          children: [
            {
              label: "Config",
              key: "ConfigMenu",
              icon: <ToolOutlined />,
              children: [
                {
                  label: <Link to="/Config">Config</Link>,
                  key: "Config",
                  icon: <ToolOutlined />,
                },
                {
                  label: <Link to="/ConfigGrupo">Config Grupo</Link>,
                  key: "ConfigGrupo",
                  icon: <UsergroupAddOutlined />,
                },
                {
                  label: <Link to="/ConfigPadrao">Config Padrão</Link>,
                  key: "ConfigPadrao",
                  icon: <ToolOutlined />,
                },
                {
                  label: (
                    <Link to="/ConfigPadraoValor">Config Padrão Valor</Link>
                  ),
                  key: "ConfigPadraoValor",
                  icon: <ToolOutlined />,
                },
              ],
            },
            {
              label: <Link to="/Permissoes">Permissões</Link>,
              key: "Permissoes",
              icon: <SafetyOutlined />,
            },
            {
              label: "Frases",
              Key: "FrasesMenu",
              icon: <SnippetsOutlined />,
              children: [
                {
                  label: <Link to="/Frase">Frase</Link>,
                  key: "Frase",
                  icon: <BookOutlined />,
                },
                {
                  label: <Link to="/GrupoFrase">Grupo</Link>,
                  key: "Grupo",
                  icon: <UsergroupAddOutlined />,
                },
              ],
            },
            {
              label: <Link to="/Versao-historico">Versão Histórico</Link>,
              key: "Verso Histórico",
              icon: <FileDoneOutlined />,
            },
            {
              label: <Link to="/Alerta">Alerta</Link>,
              key: "Alerta",
              icon: <AlertOutlined />,
            },
            {
              label: <Link to="/Provimento">Fornecedor Prov. 74</Link>,
              key: "Fornecedor Prov. 74",
              icon: <RiseOutlined />,
            },
          ],
        }
      : null,
    currentUser.is_superuser || currentUser.is_staff
      ? {
          label: "Banco de Dados",
          key: "BancoMenu",
          icon: <DatabaseOutlined />,
          children: [
            {
              label: <Link to="/Dominio">Domínio</Link>,
              key: "Dominio",
              icon: <LaptopOutlined />,
            },
            {
              label: <Link to="/Tabela">Tabela</Link>,
              key: "Tabela",
              icon: <TableOutlined />,
            },
            {
              label: <Link to="/Procedure">Procedure</Link>,
              key: "Procedure",
              icon: <DeliveredProcedureOutlined />,
            },
            {
              label: <Link to="/View">View</Link>,
              key: "View",
              icon: <FolderViewOutlined />,
            },
            {
              label: <Link to="/Comandos">Comandos</Link>,
              key: "Comandos",
              icon: <MacCommandOutlined />,
            },
            {
              label: <Link to="/Sequences">Sequences</Link>,
              key: "Sequences",
              icon: <RetweetOutlined />,
            },
            {
              label: <Link to="/Em-Teste">Consulta Em Teste</Link>,
              key: "Em-Teste",
              icon: <SnippetsFilled />,
            },
          ],
        }
      : null,
    currentUser.is_superuser ||
    currentUser.is_support ||
    currentUser.is_manager ||
    currentUser.is_staff
      ? {
          label: "Relatorios",
          icon: <FileTextOutlined />,
          children: [
            {
              label: <Link to="/RelatorioGrupo">Relatório Grupo</Link>,
              key: "Relatório Grupo",
              icon: <FileZipOutlined />,
            },
            {
              label: <Link to="/Relatorio">Relatório</Link>,
              key: "Relatório",
              icon: <FileTextOutlined />,
            },
          ],
        }
      : null,
    {
      label: "Monitoramento",
      icon: <EyeOutlined />,
      children: [
        {
          label: <Link to="/Aplicacoes">Aplicações</Link>,
          key: "Aplicações",
          icon: <RetweetOutlined />,
        },
        {
          label: <Link to="/z-api">Z-API</Link>,
          key: "Z-API",
          icon: <ApiOutlined />,
        },
      ],
    },
    currentUser.is_superuser ||
    currentUser.is_support ||
    currentUser.is_manager ||
    currentUser.is_staff
      ? {
          label: <Link to="/Implantacao">Implantações</Link>,
          key: "Implantacao",
          icon: <DeploymentUnitOutlined />,
        }
      : null,
    currentUser.is_superuser ||
    currentUser.is_support ||
    currentUser.is_manager ||
    currentUser.is_staff
      ? {
          label: "Movimentação",
          key: "Movimentação",
          icon: <ThunderboltOutlined />,
          children: [
            {
              label: <Link to="/Atualizacao">Atualização</Link>,
              key: "Atualizacao",
              icon: <RedoOutlined />,
            },
            {
              label: <Link to="/Atualizacao-forcada">Atualização Forçada</Link>,
              key: "Atualizacao forcada",
              icon: <LoginOutlined />,
            },
            {
              label: <Link to="/Atualizar-executavel">Executáveis</Link>,
              key: "Atualizar executavel",
              icon: <FileSyncOutlined />,
            },
          ],
        }
      : null,
  ];

  return (
    <Menu items={items} theme={"dark"} mode={"inline"} className="ant-menu" />
  );
};

export default MenuPrincipal;
